// @flow
import environment from '../../environment';
import { getCreator } from '../../http';

export const endpoints = Object.freeze({
  GET_STORES: `${environment.apiUrl}/store/list`,
});

export const getStoresApi = getCreator(fetch, endpoints.GET_STORES);



// WEBPACK FOOTER //
// ./src/modules/stores/api.js